import * as React from "react";

function SvgCreditCard(props) {
  return <svg width={27} height={20} viewBox="0 0 27 20" fill="none" {...props}><path d="M27 8.29753H0V18.2068C0 19.2414 0.8853 20 1.9182 20H25.008C26.1147 20 27 19.2392 27 18.2735V8.29753ZM8.5338 16.25H3.3471V14.5833H8.53365L8.5338 16.25ZM0 5.79753H27V1.79296C27 0.75845 26.1147 0 25.0818 0H1.992C0.8853 0 0 0.827465 0 1.79296V5.79753Z" fill="currentColor" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/credit-card_af7a1e.svg";
export { SvgCreditCard as ReactComponent };